module.exports = __webpack_public_path__ + "img/flag-EC.7b1be908.svg";